// Boot-time read of the kiosk token from the URL. Imported transitively from
// config.ts and AuthContext.tsx, so the parse runs before anything else reads
// the URL or makes an API call. Token presence is the single signal: it
// drives token-header forwarding, the AuthContext short-circuit, and the
// chrome-stripped layout. No separate render-mode flag — kiosk = unattended
// display, and unattended displays don't need (or want) the chrome.
//
// The kiosk token stays in the URL on purpose. OptiSigns may implement its
// refresh interval as location.reload(); stripping the token via replaceState
// would leave the reloaded URL un-authenticated. Browser-chrome exposure is
// moot (kiosks hide it); API requests use X-Kiosk-Token header, not the URL,
// so per-poll log entries already don't carry the token.

const params = new URLSearchParams(window.location.search);
const KIOSK_TOKEN = params.get('kiosk_token');

export const isKioskMode = (): boolean => KIOSK_TOKEN !== null && KIOSK_TOKEN.length > 0;
export const getKioskToken = (): string | null => KIOSK_TOKEN;
